import { Button, message, Tag } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import DynamicTable from "../../components/DynamicTable";
import TransactionModal from "./components/TransactionModal";
import DateRangeSelect from "../../components/DateRangeSelect";

const DEFAULT_COLUMNS = {
  user: {
    show: true,
    label: "User",
    key: "user",
  },
  type: {
    show: true,
    label: "Type",
    key: "type",
  },
  amount: {
    show: true,
    label: "Amount",
    key: "amount",
  },
  note: {
    show: true,
    label: "Note",
    key: "note",
  },
  date_create: {
    show: true,
    label: "Date",
    key: "date_create",
  },
};

function Transactions() {
  const [transactions, setTransactions] = useState([]);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [dateRange, setDateRange] = useState([
    moment().subtract(7, "days").startOf("day"),
    moment().startOf("day"),
  ]);

  useEffect(() => {
    fetchTransactions(dateRange);
  }, []);

  const fetchTransactions = async (dateRange) => {
    let from = dateRange[0];
    let to = dateRange[1];
    const res = await apiRequest({
      path: apiPaths.transactions + `?date_from=${from}&date_to=${to}`,
    });
    if (!res.error) {
      setTransactions(res.results);
    } else {
      message.error(res.error_description);
    }
  };

  const getType = (record) => {
    if (record.note.toLowerCase().includes("plan purchase")) {
      return <Tag color={"blue"}>{"Plan"}</Tag>;
    }
    if (record.debit_amt) {
      return <Tag color={"green"}>{"Debit"}</Tag>;
    }
    return <Tag color={"orange"}>{"Credit"}</Tag>;
  };

  const COLUMNS = [
    {
      title: "User",
      dataIndex: "user.user_email",
      fixed: "left",
      width: 100,
      filterType: "search",
      render: (_, record) => {
        return (
          <div>
            <div>{record.user?.user_email}</div>
          </div>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      width: 60,
      filters: [
        {
          text: "Debit",
          value: "debit",
        },
        {
          text: "Credit",
          value: "credit",
        },
      ],
      onFilter: (value, record) => {
        if (value == "debit" && record.debit_amt) {
          return true;
        }
        if (value == "credit" && record.credit_amt) {
          return true;
        }
        return false;
      },
      render: (value, record) => getType(record),
    },
    {
      title: "Old Balance",
      dataIndex: "old_balance",
      width: 70,
      render: (value) => "₹" + value,
    },

    {
      title: "Amount",
      dataIndex: "amount",
      width: 70,
      render: (value, record) => "₹" + (record.credit_amt || record.debit_amt),
    },
    {
      title: "Current Balance",
      dataIndex: "balance",
      width: 70,
      render: (_, record) => {
        if (record.note.toLowerCase().includes("plan purchase")) {
          return "₹" + record.old_balance;
        }
        return (
          "₹" + (record.old_balance + record.credit_amt - record.debit_amt)
        );
      },
    },
    {
      title: "Note",
      dataIndex: "note",
      filterType: "search",
      width: "200px",
    },

    {
      title: "Date",
      dataIndex: "date_create",
      filterType: "date",
      width: "100px",
      render: (_, record) => {
        return moment(record.date_create).format("DD-MM-YYYY hh:mm a");
      },
    },
  ];

  const handleDelete = async (row) => {
    const res = await apiRequest({
      path: apiPaths.transactions + `/${row._id}`,
      method: "DELETE",
    });
    if (!res.error) {
      let updatedTrsx = transactions.filter((trx) => trx._id != row._id);
      setTransactions(updatedTrsx);
    }
  };

  const handleAddTransaction = async (values) => {
    const res = await apiRequest({
      path: apiPaths.transactions,
      method: "POST",
      data: values,
    });
    if (!res.error) {
      setTransactions([
        { user: { user_email: values.user_email }, ...res },
        ...transactions,
      ]);
      setShowTransactionModal(false);
    } else {
      message.error(res.error_description);
    }
  };

  return (
    <div style={{ height: "80vh" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <div>
          {"Date Range: "}
          <DateRangeSelect
            selectedRange={dateRange}
            onSelectedRangeChanged={(dateRange) => {
              setDateRange(dateRange);
              fetchTransactions(dateRange);
            }}
          />
        </div>
        <Button
          type="primary"
          onClick={() => {
            setShowTransactionModal(true);
          }}
        >
          Add Transaction
        </Button>
      </div>
      <div style={{ height: "80%", marginTop: 30 }}>
        <DynamicTable
          dataSource={transactions}
          columns={COLUMNS}
          defaultColumns={DEFAULT_COLUMNS}
          // deleteBtn
          onRowDelete={handleDelete}
          showAction={() => false}
          scroll={{ y: "68vh" }}
          pagination={{
            pageSize: 200,
          }}
        />
      </div>
      {showTransactionModal ? (
        <TransactionModal
          open={true}
          onSave={handleAddTransaction}
          onCancel={() => {
            setShowTransactionModal(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default Transactions;
